import { useRouter } from 'next/router';

import { UIPaths } from '@consts';
import { useTranslation } from 'react-i18next';

import { Button } from '@basic';
import { MountainWithFlagIcon } from '@icons';

interface GoToGoalSubscriptionButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  goalEntityId: string;
  goalSubscriptionId: number;
  onClickCallback?: () => void;
}

const GoToGoalSubscriptionButton = ({
  disabled = false,
  goalEntityId,
  goalSubscriptionId,
  onClickCallback = () => {},
  ...props
}: GoToGoalSubscriptionButtonProps) => {
  const router = useRouter();
  const { t } = useTranslation();

  const onGoToSubscription = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!goalEntityId || !goalSubscriptionId) return;
    router.push(UIPaths.assignments(goalEntityId, goalSubscriptionId));
    onClickCallback();
  };

  return (
    <Button
      onClick={onGoToSubscription}
      type='primary'
      size='medium'
      disabled={disabled}
      fullWidth={true}
      {...props}
    >
      <MountainWithFlagIcon size={20} />
      <span>{t('components.goToGoalSubscriptionButton.goToSubscription')}</span>
    </Button>
  );
};

export default GoToGoalSubscriptionButton;
